import React from 'react';

// The External Components
import TopSection from './Components/TopSection/TopSection';
import { Entireelement, InternalComponents } from './PagesStyles';
import Slider from './Components/InfoSlider/Slider';
import Gallery from './Components/OurTeam/Gallery';
import Footer from './Components/Footer/Footer';

export default function Pages() {
  return (
    <>
      <Entireelement>
        <InternalComponents>
          <TopSection />
          <Slider />
          <Gallery />
          <Footer />
        </InternalComponents>
      </Entireelement>
    </>
  );
}
